<template>
  <v-container fluid class="align-start" style="margin-bottom: 56px">
    <v-card width="100%" class="mb-5">
      <v-container fluid class="pa-0">
        <v-layout>
          <v-row class="ma-0" style="max-width: 100%">
            <v-col class="pa-0">
              <v-row class="ma-0 px-4 pb-4 pt-1" align="center">
                <v-col class="px-0 pb-0 pt-3" cols="auto">
                  <v-toolbar-title style="min-width: 80px"> {{ $t('workSchedules.schedules')}} </v-toolbar-title>
                </v-col>
                <v-divider class="mt-3 mx-3" vertical/>
                <v-spacer v-if="!isMdOrLargerViewport()"/>
                <v-col class="pa-0" cols="auto">
                  <v-row class="ma-0" align="center">
                    <div class="px-0 pb-0 pt-3">
                      <v-btn
                        @click="resetViewRangeDates"
                        outlined
                        small
                      >
                        {{ resetButtonText }}
                      </v-btn>
                    </div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div class="px-0 pb-0 pt-3">
                          <v-btn
                            @click="handleTimeRangePreviousPage()"
                            v-on="on"
                            text
                            icon
                          >
                            <v-icon class="pl-0">navigate_before</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>{{ previousTimeRangeTooltip }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div class="px-0 pb-0 pt-3">
                          <v-btn
                            @click="handleTimeRangeNextPage()"
                            v-on="on"
                            text
                            icon
                          >
                            <v-icon class="pl-0">navigate_next</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>{{ nextTimeRangeTooltip }}</span>
                    </v-tooltip>
                    <div class="text-h6 px-0 pb-0 pt-3">{{ currentTimeRange }}</div>
                  </v-row>
                </v-col>
                <v-spacer v-if="isMdOrLargerViewport()"/>
                <v-col class="pa-0" cols="auto" :style="{ width: isMdOrLargerViewport() ? '115px' : '100%' }">
                  <v-row class="ma-0">
                    <v-col class="pa-0" cols="auto" :style="{ width: isXsViewport() ? '100%' : '130px' }">
                      <v-select
                        @change="handleViewRangeChange"
                        v-model="viewRange.range"
                        :items="viewRanges"
                        class="pt-3"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider/>
              <v-row class="ma-0 pa-4" align="center">
                <v-col class="pa-0">
                  <v-row
                    :class="{ 'ma-0':  true, 'flex-nowrap': !isXsViewport() }"
                    style="border: 1px solid #E0E0E0; position: sticky; z-index: 4; top: 65px"
                  >
                    <v-col
                      :style="{ width: isXsViewport() ? '100%' : '240px !important' }"
                      cols="auto"
                      class="pa-0"
                    >
                      <v-card flat tile height="50px" class="ma-0" style="border-right: 1px solid #E0E0E0">
                        <v-row class="ma-0 pl-4 fill-height" align="center">
                          <div class="pa-0 ma-0 font-italic"> {{ $t('clock.assignments') }} </div>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col
                      class="pa-0"
                      :style="{ 'max-width': isXsViewport() ? '100%' : 'calc(100% - 240px)' }"
                    >
                      <v-row
                        v-on:scroll="scrollAllBars($event)"
                        ref="ws_bar_ticks"
                        style="overflow-x: auto"
                        class="ma-0"
                      >
                        <v-row
                          :style="{ 'min-width': getBarMinWidth() }"
                          class="ma-0 text-center"
                          justify="center"
                        >
                          <v-col
                            v-for="(tick, index) in viewRangeTicks"
                            v-bind:key="index"
                            :style="{
                                borderLeft: '1px solid var(--v-info-darken1)',
                                borderTop: '1px solid var(--v-info-darken1)'
                              }"
                            class="pa-0"
                          >
                            <v-row
                              :style="{
                              backgroundColor: index % 2 === 0 ? 'var(--v-info-base)' : 'white',
                              height: '25px'
                            }"
                              class="ma-0 text-overline"
                              align="end"
                              justify="center"
                            >
                              {{ tick.upperText }}
                            </v-row>
                            <v-row
                              :style="{
                              backgroundColor: index % 2 === 0 ? 'var(--v-info-base)' : 'white',
                              height: '25px'
                            }"
                              class="ma-0 text-caption"
                              align="start"
                              justify="center"
                            >
                              {{ tick.lowerText }}
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0 flex-nowrap" style="border: 1px solid #E0E0E0;">
                    <v-card :loading="!schedulesLoaded" flat tile width="100%">
                      <v-row
                        v-for="(assignment, index) in employeeWorkSchedules"
                        :ref="getBarRef(assignment.id)"
                        :class="{ 'ma-0': true, 'flex-nowrap': !isXsViewport() }"
                        :style="{ 'height': getBarHeight(), 'overflow': 'hidden' }"
                        :key="index"
                      >
                        <v-col
                          :style="{
                            width: isXsViewport() ? '100%' : '240px !important',
                            height: isXsViewport() ? '20px' : getBarHeight(),
                            maxHeight: isXsViewport() ? '20px' : getBarHeight(),
                            position: isXsViewport() ? 'sticky' : 'static',
                            left: '0'
                          }"
                          cols="auto"
                          class="pa-0"
                        >
                          <v-list-item
                            :value="assignment.assignmentId"
                            :style="{
                              height: isXsViewport() ? '20px' : getBarHeight(),
                              minHeight: isXsViewport() ? '40px' : getBarHeight(),
                            }"
                            v-ripple="false"
                            dense
                          >
                            <template v-slot:default="">
                              <v-list-item-content>
                                <v-row class="ma-0" align="center">
                                  <div style="width: 210px">
                                    {{ assignment.currentPosition }}
                                  </div>
                                  <div style="font-size: 12px; padding-top: 5px; word-wrap: break-word">
                                    {{ `${assignment.assignmentId}` }}
                                  </div>
                                </v-row>
                              </v-list-item-content>
                            </template>
                          </v-list-item>
                          <v-divider :key="`divider-${index}`"/>
                        </v-col>
                        <v-col
                          class="pa-0"
                          :style="{ 'max-width': isXsViewport() ? '100%' : 'calc(100% - 240px)', height: '41px' }"
                        >
                          <v-row
                            v-on:scroll="scrollAllBars($event, assignment.assignmentId)"
                            v-if="schedulesLoaded"
                            style="overflow-x: visible"
                            class="ma-0"
                          >
                            <v-fade-transition hide-on-leave>
                              <v-card
                                v-show="schedulesLoaded"
                                :style="{ 'min-width': getBarMinWidth() }"
                                width="100%"
                                flat
                                tile
                              >
                                <v-row v-if="schedulesLoaded" class="ma-0">
                                  <v-col class="pa-0">
                                    <v-card
                                      flat
                                      style="background-color: #f5f5f5"
                                    >
                                      <v-row
                                        class="ma-0"
                                        :style="{height: getBarHeight()}"
                                      >
                                        <work-schedule-block
                                          :key="index"
                                          :is-week-view="isWeekView"
                                          :view-range="viewRange"
                                          :schedule="getDailyWorkScheduleByEmployee(employee.id)"
                                          @viewMoreInfo="viewScheduleDetails"
                                        />
                                      </v-row>
                                      <v-divider/>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-fade-transition>
                          </v-row>
                          <v-row
                            v-else
                            class="ma-0"
                            style="border-bottom: 1px solid #E0E0E0; border-left: 1px solid #E0E0E0; height:100%"
                            justify="center"
                            align="center"
                          >
                            <span class="text-overline">
                              {{ $t('workSchedules.loadingSchedules') }}
                            </span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-layout>
      </v-container>
    </v-card>
    <v-bottom-navigation grow fixed dark background-color="primary">
      <v-spacer/>
    </v-bottom-navigation>
    <WorkScheduleDetailsDialog
      :value="workScheduleDetailsDialog"
      :work-schedule-external-code="selectedExternalCode"
      @close="handleWorkScheduleDetailsDialogClose"
    />
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import constants from '@/constants';

import displayAdaptable from '@/mixins/displayAdaptable';
import hasSnackbar from '@/mixins/hasAppSnackbar';

import WorkScheduleDetailsDialog from '@/components/dialogs/WorkScheduleDetailsDialog.vue';

import DateTimeUtil from '@/util/date-time-util';

import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';
import first from 'lodash/first';
import filter from 'lodash/filter';

import format from 'date-fns/format';
import WorkScheduleBlock from '@/components/WorkScheduleRow.vue';
import workSchedule from '../../workSchedule';

export default {
  name: 'EmployeeWorkSchedules',

  mixins: [displayAdaptable, hasSnackbar, workSchedule],

  components: {
    WorkScheduleBlock,
    WorkScheduleDetailsDialog,
  },

  data() {
    return {
      workScheduleDetailsDialog: false,
      selectedExternalCode: '',
    };
  },

  created() {
    this.setPageTitle(this.$t('titles.myWorkSchedule'));
    this.resetViewRangeDates();
    this.loadWorkSchedules().then(() => {
      this.loadEmployeeSchedules({
        startDate: format(this.viewRange.startDate, DateTimeUtil.constants.dateFormat),
        endDate: format(this.viewRange.endDate, DateTimeUtil.constants.dateFormat),
      }).then(() => {
        this.setWorkScheduleSegments();
        this.schedulesLoaded = true;
      });
    });
  },

  computed: {
    ...mapState(['employeeSchedules', 'employee']),

    ...mapGetters(['getEmployeeSchedules', 'getDailyWorkScheduleByEmployee']),

    employeeWorkSchedules() {
      return this.employeeSchedules;
    },
  },

  methods: {
    ...mapActions([
      'loadWorkSchedules',
      'loadSubordinateEmployees',
      'loadEmployeeSchedules',
    ]),
    ...mapMutations(['setPageTitle']),

    fetchAssignedWorkScheduleRanges() {
      this.schedulesLoaded = false;
      this.loadEmployeeSchedules({
        startDate: format(this.viewRange.startDate, DateTimeUtil.constants.dateFormat),
        endDate: format(this.viewRange.endDate, DateTimeUtil.constants.dateFormat),
      }).finally(() => {
        this.setWorkScheduleSegments();
        this.schedulesLoaded = true;
      });
    },

    setWorkScheduleSegments() {
      this.setDailyWorkScheduleForEmployee([this.employee.id]);
    },

    handleWorkScheduleDetailsDialogClose() {
      this.selectedExternalCode = '';
      this.workScheduleDetailsDialog = false;
    },

    viewScheduleDetails(range) {
      if (range.type === 'WORK_SCHEDULE' && range.externalCode) {
        this.selectedExternalCode = range.externalCode;
        this.workScheduleDetailsDialog = true;
      }
    },

    getWorkingTimeRangeFromDay(workScheduleDay) {
      const workingSegments = filter(
        workScheduleDay.segments,
        (segment) => segment.category === constants.WorkSchedule.SegmentType.SCHEDULED_WORKING_TIME,
      );

      const duration = this.getWorkingDuration(workScheduleDay.segments);

      return isEmpty(workingSegments)
        ? 'Non-Working Day'
        : `${first(workingSegments).startTime} - ${last(workingSegments).endTime} (${duration})`;
    },

    getWorkSchedule(externalCode) {
      return this.getWorkScheduleByExternalCode(externalCode);
    },
  },
};
</script>

<style scoped>

</style>
